import { createContext } from 'react'

import { ActivityTagsContextType } from './ActivityTagsContext.types'

export const ActivityTagsContext = createContext<ActivityTagsContextType | undefined>(undefined)
